export default __webpack_public_path__ + "static/media/mw15.a64b4234.webp";